import React from 'react'
import { Grid } from '@material-ui/core'
import { Link, useRouteMatch } from 'react-router-dom'
import Divider from '../../../../components/atoms/Divider'
import PageLayout from '../common/PageLayout'
import SydLinkButton from '../../../../components/commonDesign/LinkButton'
import OpalHeading from '../../../../components/opal/OpalHeading'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import denaliExpert from '../../../../assets/denali_expert.webp'
import denaliSecurity from '../../../../assets/denali_security.webp'
import PersonalSpace from '../../../../components/molecules/PersonalSpace'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import StyledLink from '../common/StyledLink'
import BrandedDocument from '../../../../components/molecules/BrandedDocument'

function SettingsHome () {
  const { path } = useRouteMatch()

  return (
    <PageLayout className='font-serif' variant='constrained'>
      <FlexColumn style={{ gap: '32px' }}>
        <FadeIn delay={0} duration={1} timing='ease-out'>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <OpalHeading className='font-size-xl'>Use AI Responsibly. You're still the expert.</OpalHeading>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FlexRow className='justify-center items-center h-full p-sm'>
                <Link to='/denali-ai/settings/preferences'>
                  <BrandedDocument imageUrl={denaliExpert} name='My Preferences' />
                </Link>
              </FlexRow>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FlexColumn className='gap-xl justify-center items-center h-full font-size-md'>
                <p className='m-0'>
                  You're the reason there's a human in the loop here. Denali AI delivers insights, but decisions stay human.
                  Review, verify, and apply your best judgement.
                </p>
                <p className='m-0'>
                  If you ever need a refresher, you can review our <StyledLink href='https://orion.com/ai-services-acceptable-use-policy' title='AI Acceptable Use' newTab>AI Acceptable Use</StyledLink> and <StyledLink href='https://orion.com/ai-addendum' title='AI Terms & Conditions' newTab>AI Terms & Conditions</StyledLink>
                </p>
              </FlexColumn>
            </Grid>
          </Grid>
        </FadeIn>
        <FadeIn delay={0.1} duration={1.2}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <FlexRow className='justify-end'>
                <OpalHeading className='font-size-xl'>Smart Orchestration. Fewer Tokens.</OpalHeading>
              </FlexRow>
              <Divider />
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center h-full font-size-md'>
                <p>
                  Denali automatically selects and coordinates the right models to get the job done - maximizing performance
                  and minimizing cost.
                </p>
              </FlexRow>
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center font-sans h-full'>
                <SydLinkButton size='xl' variant='primary' to={`${path}/usage`}>Token Usage Insight</SydLinkButton>
              </FlexRow>
            </Grid>
          </Grid>
        </FadeIn>
        <FadeIn delay={0.2} duration={1.3}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <FlexRow className='justify-start'>
                <OpalHeading className='font-size-xl'>These models are currently on active duty.</OpalHeading>
              </FlexRow>
              <Divider />
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center font-sans h-full'>
                <SydLinkButton size='xl' variant='primary' to={`${path}/models`}>Current Models</SydLinkButton>
              </FlexRow>
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center h-full font-size-md'>
                <p>
                  These are subject to change. We're continually evaluating the best and the brightest out there.
                </p>
              </FlexRow>
            </Grid>
          </Grid>
        </FadeIn>
        <FadeIn delay={0.3} duration={1.4}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <FlexRow className='justify-end'>
                <OpalHeading className='font-size-xl'>Your Data. Your Rules.</OpalHeading>
              </FlexRow>
              <Divider />
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center h-full font-size-md'>
                <p>
                  A quick look at the data sources you've chosen to share with Denali AI.
                </p>
              </FlexRow>
            </Grid>
            <Grid item xs={12} md={6}>
              <FlexRow className='justify-center items-center font-sans h-full'>
                <SydLinkButton size='xl' variant='primary' to={`${path}/catalog`}>Data Insight</SydLinkButton>
              </FlexRow>
            </Grid>
          </Grid>
        </FadeIn>
        <FadeIn delay={0.4} duration={1.45}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <FlexRow className='justify-start'>
                <OpalHeading className='font-size-xl'>Enterprise-Grade Security, by Design.</OpalHeading>
              </FlexRow>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FlexColumn className='gap-xl justify-center items-center h-full font-size-md'>
                <p className='m-0'>
                  Denali AI follows Orion's enterprise security standards. Your data is encrypted at rest and at transit,
                  managed within a single-tenant environment.
                </p>
                <p className='m-0'>
                  Our models cannot be trained on your data -- and physical isolation ensure your firm's data never crosses
                  paths with another's.
                </p>
              </FlexColumn>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FlexRow className='justify-center items-center h-full p-sm'>
                <img
                  className='radius-md shadow-md'
                  style={{
                    maxWidth: '80%'
                  }}
                  src={denaliSecurity}
                  alt='A secure and modern looking data center'
                />
              </FlexRow>
            </Grid>
          </Grid>
        </FadeIn>
      </FlexColumn>
      <PersonalSpace />
    </PageLayout>
  )
}

export default SettingsHome
